// Verdict global — règles documentées (docs/PASSWORD_TESTER.md), sans score marketing opaque :
// 1) au moins une occurrence dans une source de compromission => "compromised" (prime sur tout) ;
// 2) sinon niveau issu du score zxcvbn (0..4) ;
// 3) un motif contextuel (service / infos saisies) plafonne à "weak".
export const VERDICT_BY_SCORE = ["veryWeak", "weak", "fair", "strong", "veryStrong"];

export function globalVerdict({ score, breach, patterns = [] }) {
  if (breach?.status === "compromised") return "compromised";
  if (score == null) return null;
  let v = VERDICT_BY_SCORE[score];
  if (patterns.includes("userInput") && score > 1) v = "weak";
  return v;
}

export const needsReplacement = (v) => ["compromised", "veryWeak", "weak", "fair"].includes(v);
export const SCORE_LEVEL = VERDICT_BY_SCORE;
